import * as Yup from 'yup';
import { isAfter, isValid, parseISO } from 'date-fns';

const areCreatedAtFiltersValid = (fromStr?: string, toStr?: string): boolean => {
  if (!fromStr || !toStr) return true;

  const from = parseISO(fromStr);
  const to = parseISO(toStr);

  if (!isValid(from) || !isValid(to)) return true;

  return !isAfter(from, to);
};

export const jobApplicationSerpFiltersFormSchema = Yup.object({
  createdAtFrom: Yup.string()
    .test(
      'createdAtFrom-is-valid-date',
      'La data "dal" non è valida',
      (value) => !value || isValid(parseISO(value)),
    )
    .test(
      'createdAtFrom-before-createdAtTo',
      'La data "dal" deve essere precedente alla data "al"',
      (value, { parent }) => areCreatedAtFiltersValid(value, parent.createdAtTo),
    ),
  createdAtTo: Yup.string()
    .test(
      'createdAtTo-is-valid-date',
      'La data "al" non è valida',
      (value) => !value || isValid(parseISO(value)),
    )
    .test(
      'createdAtTo-after-createdAtFrom',
      'La data "al" deve essere successiva alla data "dal"',
      (value, { parent }) => areCreatedAtFiltersValid(parent.createdAtFrom, value),
    ),
});
